import DropDownMenu from '../../atoms/DropDownMenu/DropDownMenu'
import UserInformativeIcon from '../../atoms/Icons/Informative/User'
import UserBtnIcon from '../../atoms/Icons/Button/User'
import LogOutIcon from '../../atoms/Icons/Button/LogOut'
import Link from '../../atoms/Link/Link'
import Button from '../../atoms/Button/Button'
import colors from '../../theme/colors'

import styled from 'styled-components'
import Breakpoints from '../../theme/breakpoints'
import { Action } from '../../../util/analytics-data-attributes/analyticsAttributes'

const Header = styled.header`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-direction: row;
  height: 64px;
  background: ${colors.Primary.GreyWhite};
  border-bottom: 1px solid ${colors.Primary.GreyLight};
  margin-bottom: 0;

  .log-out-btn {
    border: none;
    border-radius: 0;
    justify-content: start;
  }

  .log-in-btn {
    justify-content: center;
    margin-right: 32px;
  }

  .select__content {
    z-index: 3 !important;
  }

  svg {
    margin: 0 8px;
  }

  #header-drop-down-menu {
    width: fit-content;
  }

  // Hide header on server-side rendered pages 
  @media (max-width: ${Breakpoints.tablet}) {
    display: none;
  }
`

export type DesktopHeaderProps = {
  userName: string
  className?: string
  accountUrl: string
  isLoggedIn: boolean
  onLogOut: () => void
  onLogIn: () => void
}

export const DesktopHeader: React.FunctionComponent<DesktopHeaderProps> = ({
  userName,
  className,
  onLogOut,
  accountUrl,
  onLogIn,
  isLoggedIn,
}) => {
  const user = (
    <>
      <UserInformativeIcon /> {userName}
    </>
  )

  return (
    <Header className={className}>
      {isLoggedIn ? (
        <DropDownMenu id="header-drop-down-menu" label={user} backgroundColor={colors.Primary.GreyWhite}>
          <Link dataAnalyticsAction={Action.clickOnAccount} dataAnalyticsLabel="header-dropdown" href={accountUrl}>
            <UserBtnIcon />
            Account instellingen
          </Link>
          <Button className="log-out-btn" variant={Button.Variants.secondary} onClick={onLogOut}>
            <LogOutIcon />
            Uitloggen
          </Button>
        </DropDownMenu>
      ) : (
        <Button className="log-in-btn" onClick={onLogIn} variant={Button.Variants.primaryBlack}>
          Inloggen
        </Button>
      )}
    </Header>
  )
}
